import moment from 'moment';
import 'moment-timezone';

export default function (value, utc = false, timezone = '', onlyTime = false, replaceSeconds = '', endTime = null) {
  if (!value) return '';

  let valueMoment;
  if (utc) {
    valueMoment = timezone ? moment.utc(value).tz(timezone) : moment.utc(value);
  } else {
    valueMoment = timezone ? moment(value).tz(timezone) : moment(value);
  }

  if (onlyTime) {
    let momentSource;

    if (endTime) {
      momentSource = utc ? moment.utc(endTime) : moment(endTime);
    } else {
      momentSource = utc ? moment.utc() : moment();
    }

    const nowMoment = timezone ? momentSource.tz(timezone) : momentSource;

    const duration = moment.duration(nowMoment.diff(valueMoment));

    const years = duration.asYears();
    if (years >= 1) {
      const rounded = Math.round(years);
      return `${rounded} year${rounded > 1 ? 's' : ''}`;
    }

    const months = duration.asMonths();
    if (months >= 1) {
      const rounded = Math.round(months);
      return `${rounded} month${rounded > 1 ? 's' : ''}`;
    }

    const weeks = duration.asWeeks();
    if (weeks >= 1) {
      const rounded = Math.round(weeks);
      return `${rounded} week${rounded > 1 ? 's' : ''}`;
    }

    const days = duration.asDays();
    if (days >= 1) {
      const rounded = Math.round(days);
      return `${rounded} day${rounded > 1 ? 's' : ''}`;
    }

    const hours = duration.asHours();
    if (hours >= 1) {
      const rounded = Math.round(hours);
      return `${rounded} hour${rounded > 1 ? 's' : ''}`;
    }

    const minutes = duration.asMinutes();
    if (minutes >= 1) {
      const rounded = Math.round(minutes);
      return `${rounded} min`;
    }

    const seconds = duration.asSeconds();
    return replaceSeconds || `${Math.round(seconds)} sec`;
  }

  return valueMoment.fromNow();
}
